export default __webpack_public_path__ + "static/media/logo_tall.91544103.svg";